import { createWithEqualityFn } from 'zustand/traditional';

export const _useLoadings = createWithEqualityFn((set) => ({
  startLoading: (id) => set({ [id]: true }),
  stopLoading: (id) => set({ [id]: false }),
  updateLoading: (loadings) => set(loadings),
}));

export const useLoadings = (field) => {
  if (field === false) {
    return _useLoadings.getState();
  }

  return _useLoadings((state) => (typeof field === 'string' ? state[field] : state));
};

export const getLoadings = (field) => {
  return field ? _useLoadings.getState()[field] : _useLoadings.getState();
};
